/* lagoon-quiz.js — Lagoon Sleep Fitting Quiz (Booster).
   Depends (load BEFORE this file): reviews-data.js, pillow-gallery.js, pillow-engine.js,
   and klaviyo-bridge.js (for window.lagoonSyncToKlaviyo). Mounts into every
   .lagoon-quiz .lq-screen on the page. Single responsive instance. */
const QZCFG = (window.LAGOON_QUIZ_CONFIG || {});
const FOUNDER_PHOTO = QZCFG.founderPhoto || 'assets/founder-ryan.png';
// Offer codes — auto-applied to the cart on add (ungated; fires whether or not
// the visitor gave an email, matching the legacy -recommend PDPs). The bundle
// can use its own code; if none is set it falls back to the single-pillow code
// (so a stacking AUTOMATIC bundle discount in Shopify still lands the extra $20).
const DISCOUNT_CODE   = QZCFG.discountCode || 'WELCOME20';
const DISCOUNT_BUNDLE = QZCFG.bundleDiscountCode || DISCOUNT_CODE;
// Experiment arm tag stamped on every analytics event + the GA4 user property
// (so later purchase events attribute to this arm for revenue-per-entry).
const QUIZ_VERSION = QZCFG.quizVersion || 'sleep_fitting_v2';
/* ---------------- icons (monoline, teal) ---------------- */
function svg(p,sw){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="'+(sw||1.7)+'" stroke-linecap="round" stroke-linejoin="round">'+p+'</svg>';}
const ICON = {
  neck:    svg('<path d="M3 12h4l2-5 4 10 2-5h6"/>'),
  hot:     svg('<path d="M12 3c2.2 3 4 4.4 4 8a4 4 0 0 1-8 0c0-1.2.6-2.2 1.2-3.2.4 1.8 1.8 1.8 1.8 0 0-2-1.2-2.8 1-4.8z"/>'),
  toss:    svg('<path d="M3 12a9 9 0 0 1 15-6.7L21 8"/><path d="M21 4v4h-4"/><path d="M21 12a9 9 0 0 1-15 6.7L3 16"/><path d="M3 20v-4h4"/>'),
  deep:    svg('<path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8z"/>'),
  snore:   svg('<path d="M3 8h11a3 3 0 1 0-3-3"/><path d="M3 12h15a3 3 0 1 1-3 3"/><path d="M3 16h8"/>'),
  skin:    svg('<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/>'),
  crown:   svg('<path d="M4 18h16M4 18l-1.2-9 5 3.5L12 5l4.2 7.5 5-3.5L20 18"/>'),
  side:    svg('<rect x="3" y="11" width="18" height="7" rx="3.5"/><circle cx="7" cy="8.5" r="2"/>'),
  back:    svg('<rect x="3" y="12" width="18" height="6" rx="3"/><circle cx="12" cy="8.5" r="2"/>'),
  stomach: svg('<rect x="3" y="13" width="18" height="5" rx="2.5"/><circle cx="17" cy="10" r="2"/>'),
  combo:   svg('<path d="M3 12a9 9 0 0 1 15-6.7L21 8"/><path d="M21 4v4h-4"/><path d="M21 12a9 9 0 0 1-15 6.7L3 16"/><path d="M3 20v-4h4"/>'),
  thot:    svg('<path d="M12 3c2.2 3 4 4.4 4 8a4 4 0 0 1-8 0c0-1.2.6-2.2 1.2-3.2.4 1.8 1.8 1.8 1.8 0 0-2-1.2-2.8 1-4.8z"/>'),
  neutral: svg('<circle cx="12" cy="12" r="4"/><path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.5 5.5l1.4 1.4M17.1 17.1l1.4 1.4M18.5 5.5l-1.4 1.4M6.9 17.1l-1.4 1.4"/>'),
  cold:    svg('<path d="M12 2v20M4 7l8 5 8-5M4 17l8-5 8 5M7 4l5 3 5-3M7 20l5-3 5 3"/>'),
  slender: svg('<rect x="9.5" y="4" width="5" height="16" rx="2.5"/>'),
  average: svg('<rect x="7.5" y="4" width="9" height="16" rx="3.5"/>'),
  broad:   svg('<rect x="4.5" y="4" width="15" height="16" rx="4.5"/>'),
  soft:    svg('<path d="M6.5 17a4 4 0 0 1 .4-8 5 5 0 0 1 9.6 1.2A3.5 3.5 0 0 1 16 17z"/>'),
  cushy:   svg('<rect x="3" y="9" width="18" height="8" rx="4"/><path d="M7 9V8M17 9V8"/>'),
  firm:    svg('<rect x="4" y="7" width="16" height="11" rx="2"/><path d="M4 11h16"/>'),
  notsure: svg('<circle cx="12" cy="12" r="9"/><path d="M9.6 9.2a2.5 2.5 0 0 1 4.7 1.1c0 1.6-2.3 2-2.3 3.7"/><circle cx="12" cy="17" r=".6" fill="currentColor"/>'),
  check:   svg('<path d="M20 6L9 17l-5-5"/>',2.6),
  chevL:   svg('<path d="M15 18l-6-6 6-6"/>',2.4),
  chevR:   svg('<path d="M9 6l6 6-6 6"/>',2.4),
  pcase:   svg('<rect x="3" y="6" width="18" height="12" rx="3"/><path d="M3 10h18"/>'),
  shield:  svg('<path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/>'),
  truck:   svg('<rect x="1" y="6" width="14" height="10" rx="1.5"/><path d="M15 9h4l3 3v4h-7z"/><circle cx="6" cy="18" r="1.7"/><circle cx="18" cy="18" r="1.7"/>'),
  badge:   svg('<circle cx="12" cy="9" r="6"/><path d="M9 14l-1.5 7 4.5-3 4.5 3L15 14"/>'),
  restart: svg('<path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/>',2),
  lock:    svg('<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>',2),
};

/* ---------------- questions ---------------- */
const QUESTIONS = [
  { key:'goals', multi:true, title:"What are your sleep goals?", sub:"Pick all that matter — we'll tailor your match around them.", opts:[
    { v:'neck',  icon:'neck',  name:'Wake up pain-free',   desc:'No more neck or shoulder pain', problem:'Neck / shoulder pain' },
    { v:'deep',  icon:'deep',  name:'Get deeper sleep',    desc:'Higher-quality, restorative rest', problem:'Restless / light sleep' },
    { v:'toss',  icon:'toss',  name:'Toss & turn less',    desc:'Fall asleep faster, stay settled', problem:'Tossing & turning' },
    { v:'hot',   icon:'hot',   name:'Stay cool all night', desc:'No overheating or night sweats', problem:'Sleeping hot' },
    { v:'snore', icon:'snore', name:'Breathe easier',      desc:'Snore less, breathe better', problem:'Snoring' },
    { v:'none',  icon:'crown', name:'Just upgrading',      desc:'I want the best pillow', problem:'Upgrading' },
  ]},
  { key:'position', multi:false, title:"How do you sleep?", sub:"Most nights, you settle on your…", opts:[
    { v:'side',    icon:'side',    name:'Side',         desc:'' },
    { v:'back',    icon:'back',    name:'Back',         desc:'' },
    { v:'stomach', icon:'stomach', name:'Stomach',      desc:'' },
    { v:'combo',   icon:'combo',   name:'It changes',   desc:'I move around all night' },
  ]},
  { key:'temp', multi:false, title:"Do you sleep hot or cold?", sub:"", opts:[
    { v:'hot',     icon:'thot',    name:'I sleep hot',  desc:'Cooling is a priority' },
    { v:'neutral', icon:'neutral', name:'Neutral',      desc:'Not too hot or cold' },
    { v:'cold',    icon:'cold',    name:'I sleep cold', desc:'I like to stay warm' },
  ]},
  { key:'body', multi:false, title:"Your body frame?", sub:"This sets the right loft for your neck — so we can skip asking about height.", opts:[
    { v:'slender', icon:'slender', name:'Slender', desc:'Narrower shoulders' },
    { v:'average', icon:'average', name:'Average', desc:'Medium build' },
    { v:'broad',   icon:'broad',   name:'Broad',   desc:'Wider shoulders' },
  ]},
  { key:'density', multi:false, title:"How should it feel?", sub:"Most people land right in the middle.", opts:[
    { v:'soft',    icon:'soft',    name:'Soft & cloud-like',  desc:'Light, airy, plush' },
    { v:'cushy',   icon:'cushy',   name:'Cushy & cradling',   desc:'Cozy but supportive' },
    { v:'firm',    icon:'firm',    name:'Firm & supportive',  desc:'More lift and structure' },
    { v:'notsure', icon:'notsure', name:'Not sure',           desc:'Help me decide' },
  ]},
];
const SECS_PER = 8;

/* infer loft from position + body (replaces the height question) */
function deriveHeight(position, body){
  if(position === 'stomach') return 'low';
  if(position === 'side')    return body === 'slender' ? 'medium' : 'high';
  if(position === 'back')    return body === 'broad' ? 'high' : 'medium';
  return 'medium'; // combo
}

/* assemble the engine answer object from quiz answers */
function engineAnswers(a){
  const out = {};
  if(a.position) out.position = a.position;
  if(a.temp)     out.temp = a.temp;
  if(a.body)     out.body = a.body;
  if(a.density)  out.density = a.density;
  if(Array.isArray(a.goals) && a.goals.length){
    out.goals = a.goals.slice();                            // full list drives pillowcase overrides
    const primary = a.goals[0];                             // primary goal drives concern weight
    out.concern = (primary === 'deep') ? 'none' : primary;  // deep sleep / upgrade = neutral concern
  }
  if(a.position && a.body) out.height = deriveHeight(a.position, a.body);
  return out;
}

function whyBullets(pillowId, ans){
  if (window.LAGOON_PILLOW_WHY) return window.LAGOON_PILLOW_WHY(pillowId, ans);
  const R = window.LAGOON_REASONS, out = [];
  const order = ['position','concern','temp','density','body'];
  order.forEach(d=>{
    if(out.length>=3) return;
    const v = ans[d];
    if(v && R[d] && R[d][v]){ out.push(cap(R[d][v])); }
  });
  return out;
}
function pretty(id){ const p=(window.LAGOON_PILLOWS||[]).find(x=>x.id===id); return p?p.name:'This pillow'; }
function cap(s){ return s.charAt(0).toUpperCase()+s.slice(1); }

function socialProof(id){
  const s = window.LAGOON_SALES_30D; if(!s) return '';
  const r = s.rank.indexOf(id);
  if(r===0) return '#1 best-selling Lagoon pillow this month';
  if(r===1) return '2nd best-seller this month';
  if(r>=0)  return 'Loved by thousands of Lagoon sleepers';
  return '';
}

/* confidence-building hero line built from the visitor's own answers */
function confidenceLine(ans){
  const POS={side:'side sleepers',back:'back sleepers',stomach:'stomach sleepers',combo:'combo sleepers'};
  const GOAL={neck:'wake up pain-free',hot:'sleep cooler',toss:'stop tossing & turning',none:'sleep deeper',snore:'breathe easier',wrinkles:'protect skin & hair'};
  const pos = ans.position && POS[ans.position];
  const goal = ans.concern && GOAL[ans.concern];
  if(pos && goal) return 'Built for '+pos+' who want to '+goal+'.';
  if(pos) return 'Built for '+pos+'.';
  return 'Tailored to your sleep profile.';
}

/* outcome-first headlines (Concept 1) — performance-forward, driven by the
   highest-priority selected goal; secondary goals become small chips. */
const OUTCOME = {
  neck:     'Wake up pain-free, ready to move.',
  deep:     'Sleep deeper. Wake up sharper.',
  toss:     'Settle in. Stay asleep.',
  hot:      'Sleep cool, all night long.',
  snore:    'Breathe easier, sleep quieter.',
  none:     'The upgrade your sleep has been missing.',
  wrinkles: 'Wake up to healthier skin & hair.',
};
const GOAL_PRIORITY = ['neck','deep','toss','hot','snore','none'];
const GOAL_SHORT = { neck:'Pain-free', deep:'Deeper sleep', toss:'Less tossing', hot:'Cooler', snore:'Easier breathing', none:'Upgrading', wrinkles:'Skin & hair' };
function primaryGoal(goals){
  if(!Array.isArray(goals) || !goals.length) return null;
  for(const g of GOAL_PRIORITY){ if(goals.includes(g)) return g; }
  return goals[0];
}
function outcomeHeadline(goals){
  if(Array.isArray(goals) && goals.length >= 4) return "Your best night's sleep, dialed in.";
  const g = primaryGoal(goals);
  return (g && OUTCOME[g]) || "Your best night's sleep, dialed in.";
}
function secondaryChips(goals){
  if(!Array.isArray(goals)) return [];
  const p = primaryGoal(goals);
  return goals.filter(g => g !== p && GOAL_SHORT[g]).map(g => GOAL_SHORT[g]).slice(0, 3);
}

/* build the Klaviyo profile payload (mirrors the chat / legacy quiz; no height) */
function klaviyoProfile(a, pillowId){
  const problems = (a.goals||[]).map(v=>{
    const o = QUESTIONS[0].opts.find(x=>x.v===v); return o?o.problem:v;
  });
  return {
    'Sleep Position': a.position,
    'Sleep Temperature': a.temp,
    'Body Frame': a.body,
    'Pillow Feel': a.density,
    'Sleep Problems': problems,        // kept — email flows trigger off this
    'Recommended Pillow': pretty(pillowId),
    // event "Filled Out Survey" fires + added to list "Sleep Fitting"
  };
}

/* ---------------- quiz factory (one per frame) ---------------- */
// Click-away destinations: the DEFAULT product PDPs (not the -recommend pages).
const PDP_URL = {
  otter:      'https://lagoonsleep.com/products/the-otter?variant=40312375541889',
  fox:        'https://lagoonsleep.com/products/the-fox?variant=19852946997377',
  polarbear:  'https://lagoonsleep.com/products/the-polar-bear-reversible-adjustable-cooling-pillow?variant=40490066215041',
  chinchilla: 'https://lagoonsleep.com/products/the-chinchilla?variant=19927149838465',
  puffin:     'https://lagoonsleep.com/products/the-puffin?variant=19927149641857',
};
const PCASE_URL = {
  'cooling-pillowcase': 'https://lagoonsleep.com/products/cooling-flex-performance-pillowcase',
  'silk-pillowcase':    'https://lagoonsleep.com/products/100-mulberry-silk-luxe-pillowcase',
};
const pdpUrl  = (m) => (m && PDP_URL[m.id]) || (m && m.url) || '#';
const pcaseUrl = (c) => (c && PCASE_URL[c.id]) || (c && c.url) || '#';
// Route a PDP click through Shopify's discount link so the WELCOME20 code is
// applied to the SESSION (server-set cookie) before landing on the product
// page — otherwise visitors who click "Learn more" instead of "Add to cart"
// lose the offer. Format: /discount/CODE?redirect=/products/handle?variant=…
function offerLink(fullUrl, code){
  if(!code || !fullUrl || fullUrl === '#') return fullUrl;
  try{
    const u = new URL(fullUrl, 'https://lagoonsleep.com');
    const dest = u.pathname + u.search;                 // keep ?variant=…
    return u.origin + '/discount/' + encodeURIComponent(code) +
           '?redirect=' + encodeURIComponent(dest);
  }catch(e){ return fullUrl; }
}

// Variant IDs per product/size (and color for the cooling case). Used to pull
// LIVE prices from each PDP's /products/<handle>.js in production, and for
// add-to-cart. In this preview the fetch is cross-origin and fails, so prices
// fall back to the engine's base price (King shows same as Queen).
const VARIANTS = {
  otter:      { handle:'the-otter', Queen:'40312375541889', King:'40312375574657' },
  fox:        { handle:'the-fox', Queen:'19852946997377', King:'19852947030145' },
  polarbear:  { handle:'the-polar-bear-reversible-adjustable-cooling-pillow', Queen:'40490066215041', King:'40490066247809' },
  chinchilla: { handle:'the-chinchilla', Queen:'19927149838465', King:'39521335607425' },
  puffin:     { handle:'the-puffin', Queen:'19927149641857', King:'40128479559809' },
};
const PCASE_VARIANTS = {
  'silk-pillowcase':    { handle:'100-mulberry-silk-luxe-pillowcase', Queen:'39627433083009', King:'39627433115777' },
  'cooling-pillowcase': { handle:'cooling-flex-performance-pillowcase',
    Queen:{ White:'40505450102913', Blue:'40601835110529', Grey:'40601835143297' },
    King: { White:'40505450135681', Blue:'40601835176065', Grey:'40601835208833' } },
};
const _productCache = {};
// One fetch of /products/<handle>.js gives us BOTH live variant prices AND the
// live PDP image set — so the rec card always matches what's on the product page.
async function fetchProduct(handle){
  if(_productCache[handle] !== undefined) return _productCache[handle];
  try{
    const res = await fetch('/products/'+handle+'.js', { credentials:'same-origin' });
    if(!res.ok) throw 0;
    const data = await res.json();
    const prices = {};
    (data.variants||[]).forEach(v => { prices[String(v.id)] = v.price/100; });
    const images = (data.images||[]).map(sizedImg).filter(Boolean);
    _productCache[handle] = { prices, images };
    return _productCache[handle];
  }catch(e){ _productCache[handle] = null; return null; }
}
// Normalize a Shopify CDN image URL + request a sensible width so we don't pull
// full-res originals into a small carousel.
function sizedImg(url){
  if(!url) return url;
  if(url.indexOf('//') === 0) url = 'https:' + url;
  return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=1280';
}
async function fetchVariantPrices(handle){
  const p = await fetchProduct(handle);
  return p ? p.prices : null;
}
async function fetchPillowImages(pillowId){
  const v = VARIANTS[pillowId]; if(!v) return null;
  const p = await fetchProduct(v.handle);
  return (p && p.images && p.images.length) ? p.images : null;
}
// Synchronous read of already-warmed live images (null if the fetch hasn't
// resolved yet — caller falls back to the curated LAGOON_PILLOW_GALLERY).
function liveImagesFor(pillowId){
  const v = VARIANTS[pillowId]; if(!v) return null;
  const c = _productCache[v.handle];
  return (c && c.images && c.images.length) ? c.images : null;
}
async function fetchPillowPrices(pillowId){
  const v = VARIANTS[pillowId]; if(!v) return null;
  const map = await fetchVariantPrices(v.handle); if(!map) return null;
  const out = {};
  ['Queen','King'].forEach(sz=>{ const id=v[sz]; if(id && map[String(id)]!=null) out[sz]=map[String(id)]; });
  return Object.keys(out).length ? out : null;
}
async function fetchCasePrices(caseId){
  const v = PCASE_VARIANTS[caseId]; if(!v) return null;
  const map = await fetchVariantPrices(v.handle); if(!map) return null;
  const out = {};
  ['Queen','King'].forEach(sz=>{ let id=v[sz]; if(id && typeof id==='object') id=id.White; if(id && map[String(id)]!=null) out[sz]=map[String(id)]; });
  return Object.keys(out).length ? out : null;
}

function createQuiz(root){
  const TOTAL = QUESTIONS.length;
  const st = { step:0, phase:'quiz', answers:{ goals:[] }, cIdx:0, bundle:false, size:'Queen', match:null, complement:null };

  // Every quiz event carries quiz_version (arm) + entry_id (one quiz attempt),
  // fanned out to lumiTrack, GA4 gtag, and dataLayer/GTM.
  function track(ev, data){
    const payload = Object.assign({ quiz_version: QUIZ_VERSION, entry_id: st.entryId || null }, data || {});
    try{ if(typeof window.lumiTrack==='function') window.lumiTrack('quiz_'+ev, payload); }catch(e){}
    try{ if(typeof window.gtag==='function') window.gtag('event','quiz_'+ev, payload); }catch(e){}
    try{ if(window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event:'quiz_'+ev }, payload)); }catch(e){}
  }

  // Fire once, on the visitor's first interaction. Mints the entry_id (the
  // shared denominator for revenue-per-entry) and sets a GA4 user property so
  // the arm rides along to begin_checkout / purchase on later pages.
  function ensureStarted(){
    if(st.started) return;
    st.started = true;
    st.entryId = 'q' + Date.now().toString(36) + Math.random().toString(36).slice(2,7);
    try{ if(typeof window.gtag==='function') window.gtag('set','user_properties',{ quiz_arm: QUIZ_VERSION }); }catch(e){}
    track('start', {});
  }

  // Write the same Klaviyo fields the legacy quiz does (sleep_issues drives the
  // welcome flow). Reuses the shared klaviyo-bridge.js global.
  function syncKlaviyo(email){
    const a = st.answers;
    const profile = {
      position: a.position, temp: a.temp, body: a.body, density: a.density,
      concerns: Array.isArray(a.goals) ? a.goals : [],
      height: (a.position && a.body) ? deriveHeight(a.position, a.body) : undefined,
    };
    const recommendation = { pillow_id: st.match && st.match.id, complement_id: st.complement && st.complement.id };
    track('email_captured', { pillow: st.match && st.match.id });
    if(typeof window.lagoonSyncToKlaviyo === 'function'){ try{ window.lagoonSyncToKlaviyo({ email, profile, recommendation }); }catch(e){ console.error('[quiz] klaviyo', e); } }
    else { console.log('[quiz] Klaviyo (bridge not loaded) →', email, profile, recommendation); }
  }

  // Add pillow (+ pillowcase when bundled) to the Rebuy/Booster cart.
  async function addToCart(m, c){
    const items = [];
    const pid = (VARIANTS[m.id]||{})[st.size];
    if(pid) items.push({ id: Number(pid), quantity: 1 });
    if(st.bundle && c){
      const cv = PCASE_VARIANTS[c.id]; let cid = cv && cv[st.size];
      if(cid && typeof cid === 'object') cid = cid.White;
      if(cid) items.push({ id: Number(cid), quantity: 1 });
    }
    if(!items.length){ window.open(pdpUrl(m), '_blank'); return; }
    track('add_to_cart', { pillow: m.id, bundle: st.bundle, size: st.size });
    try{
      // Auto-apply the offer BEFORE adding so the discount cookie is set when the
      // cart opens — ungated (no email required). Bundle uses the bundle code
      // ($40); a single pillow uses the standard code ($20).
      const code = (st.bundle && DISCOUNT_BUNDLE) ? DISCOUNT_BUNDLE : DISCOUNT_CODE;
      if(code){ try{ await fetch('/discount/' + encodeURIComponent(code), { credentials:'same-origin' }); }catch(e){} }
      const res = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items }) });
      if(!res.ok) throw new Error('add ' + res.status);
      // Hand off to OUR custom side cart when it's active (it also auto-watches
      // /cart/add, but calling open() is explicit + idempotent). Fall back to
      // Rebuy/Booster only if the custom cart isn't on this page.
      if(window.LagoonCart && typeof window.LagoonCart.open === 'function'){ window.LagoonCart.open(); }
      else if(window.Rebuy && window.Rebuy.SmartCart){ if(window.Rebuy.SmartCart.reload) window.Rebuy.SmartCart.reload(); if(window.Rebuy.SmartCart.show) window.Rebuy.SmartCart.show(); }
      else if(window.BoosterTheme && window.BoosterTheme.cart && window.BoosterTheme.cart.refresh){ window.BoosterTheme.cart.refresh(); }
      else { document.dispatchEvent(new CustomEvent('rebuy:cart.change', { bubbles:true })); document.dispatchEvent(new CustomEvent('cart:refresh')); }
    }catch(e){ console.error('[quiz] add-to-cart', e); window.open(pdpUrl(m), '_blank'); }
  }

  function topbar(label, pct){
    return '<div class="top">'+
      '<button class="restart-btn" data-act="restart" title="Start over">'+ICON.restart+'</button>'+
      '<div class="brand">lagoon</div>'+
      '<div class="prog"><div class="prog-track"><div class="prog-fill" style="width:'+pct+'%"></div></div>'+
      '<span class="prog-label">'+label+'</span></div></div>';
  }

  function buildBodyInner(q){
    const sel = st.answers[q.key];
    const opts = q.opts.map(o=>{
      const on = q.multi ? (Array.isArray(sel)&&sel.includes(o.v)) : (sel===o.v);
      return '<button class="opt'+(on?' sel':'')+'" data-v="'+o.v+'">'+
        '<span class="opt-ico">'+ICON[o.icon]+'</span>'+
        '<span class="opt-txt"><span class="opt-name">'+o.name+'</span>'+(o.desc?'<span class="opt-desc">'+o.desc+'</span>':'')+'</span>'+
        '<span class="opt-check">'+ICON.check+'</span></button>';
    }).join('');
    const gridCls = (q.opts.length>=4) ? ' grid2' : '';
    return '<div class="qhead"><h2 class="q-title">'+q.title+'</h2>'+(q.sub?'<p class="q-sub">'+q.sub+'</p>':'')+'</div>'+
      '<div class="opts'+gridCls+'">'+opts+'</div>';
  }

  function buildFoot(q){
    const sel = st.answers[q.key];
    const canContinue = q.multi ? (Array.isArray(sel)&&sel.length>0) : true;
    const foot = q.multi
      ? '<button class="back-btn" data-act="back"'+(st.step===0?' disabled':'')+'>'+ICON.chevL+'Back</button>'+
        '<div class="foot-spacer"></div>'+
        '<button class="cont-btn" data-act="continue"'+(canContinue?'':' disabled')+'>Continue</button>'
      : '<button class="back-btn" data-act="back"'+(st.step===0?' disabled':'')+'>'+ICON.chevL+'Back</button>'+
        '<div class="foot-spacer"></div>'+
        '<span class="tap-hint">Tap to continue →</span>';
    return '<div class="qfoot">'+foot+'</div>';
  }

  function topLabel(q){
    const left = Math.max(5,(TOTAL-st.step)*SECS_PER);
    return q.multi?('Step '+(st.step+1)+' of '+TOTAL):((st.step+1)+' of '+TOTAL+' · ~'+left+'s');
  }

  function bindBody(bodyEl, q){
    bodyEl.querySelectorAll('.opt').forEach(b=>b.onclick=()=>{
      ensureStarted();
      const v = b.dataset.v;
      if(q.multi){
        const arr = st.answers[q.key] || [];
        const has = arr.includes(v);
        st.answers[q.key] = has ? arr.filter(x=>x!==v) : [...arr, v];
        b.classList.toggle('sel', !has);
        const cont = root.querySelector('.cont-btn');
        if(cont) cont.disabled = !(st.answers[q.key] && st.answers[q.key].length>0);
      } else {
        st.answers[q.key] = v;
        bodyEl.querySelectorAll('.opt').forEach(o=>o.classList.toggle('sel', o.dataset.v===v));
        setTimeout(advance, 180);
      }
    });
  }

  // Full (non-animated) render — first load, restart, back-from-gate.
  function paintQuestion(){
    const q = QUESTIONS[st.step];
    const pct = Math.round((st.step/TOTAL)*100);
    root.innerHTML = ''+ topbar(topLabel(q), pct)+
      '<div class="qviewport"><div class="qbody">'+buildBodyInner(q)+'</div></div>'+
      buildFoot(q);
    bindBody(root.querySelector('.qbody'), q);
    bindChrome();
  }

  // Typeform-style horizontal slide between questions.
  function slideQuestion(dir){
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const vp = root.querySelector('.qviewport');
    if(reduce || !vp){ paintQuestion(); return; }
    const q = QUESTIONS[st.step];
    const pct = Math.round((st.step/TOTAL)*100);
    // update chrome (progress + footer) in place
    const topEl = root.querySelector('.top'); if(topEl) topEl.outerHTML = topbar(topLabel(q), pct);
    const footEl = root.querySelector('.qfoot'); if(footEl) footEl.outerHTML = buildFoot(q);
    bindChrome();

    const oldBody = vp.querySelector('.qbody');
    if(oldBody) oldBody.style.pointerEvents = 'none';
    const newBody = document.createElement('div');
    newBody.className = 'qbody';
    newBody.style.transform = 'translateX('+(dir>0?'100%':'-100%')+')';
    newBody.innerHTML = buildBodyInner(q);
    vp.appendChild(newBody);
    bindBody(newBody, q);
    requestAnimationFrame(()=>{ requestAnimationFrame(()=>{
      const ease = 'transform .44s cubic-bezier(.4,0,.2,1)';
      if(oldBody){ oldBody.style.transition = ease; oldBody.style.transform = 'translateX('+(dir>0?'-100%':'100%')+')'; }
      newBody.style.transition = ease;
      newBody.style.transform = 'translateX(0)';
    });});
    setTimeout(()=>{
      if(oldBody && oldBody.parentNode) oldBody.remove();
      newBody.style.transition=''; newBody.style.transform='none';
    }, 520);
  }

  function advance(){
    const q = QUESTIONS[st.step];
    const sel = st.answers[q.key];
    track('question_answered', { step: st.step+1, question: q.key, value: JSON.stringify(sel) });
    // Also emit ONE clean event per selected answer, so GA4 shows per-answer
    // frequency without multi-select arrays exploding into combinations.
    (Array.isArray(sel) ? sel : [sel]).forEach(function(v){
      if(v != null) track('answer_selected', { question: q.key, answer: String(v) });
    });
    if(st.step < TOTAL-1){ st.step++; slideQuestion(1); }
    else { computeMatch(); st.phase='analyzing'; track('analyzing_shown', {}); renderAnalyze(); }
  }

  function renderAnalyze(){
    const steps = ['Reading your 5 answers','Comparing against 40,000+ sleepers','Assessing your perfect match'];
    root.innerHTML = ''+
      '<div class="top"><div class="brand">lagoon</div><div class="prog"><div class="prog-track"><div class="prog-fill" style="width:100%"></div></div><span class="prog-label">Finding your match…</span></div></div>'+
      '<div class="analyze">'+
        '<div class="analyze-ring"></div>'+
        '<div class="analyze-line">'+steps[0]+'…</div>'+
        '<div class="analyze-steps">'+
          steps.map((s,i)=>'<div class="analyze-step"><span class="dot">'+ICON.check+'</span>'+s+'</div>').join('')+
        '</div>'+
      '</div>';
    const stepEls = [...root.querySelectorAll('.analyze-step')];
    const lineEl = root.querySelector('.analyze-line');
    if(stepEls[0]) stepEls[0].classList.add('active');
    let i = 0;
    const BEAT = QZCFG.fastAnalyze ? 30 : 680;   // fastAnalyze only set by the verify harness; prod always 680
    const tick = ()=>{
      if(st.phase !== 'analyzing') return; // guard against restart mid-animation
      if(i < stepEls.length){
        stepEls[i].classList.add('done');
        lineEl.textContent = steps[i] + '…';
        i++;
        if(i < stepEls.length) stepEls[i].classList.add('active');
        setTimeout(tick, BEAT);
      } else {
        st.phase = 'gate';
        renderGate();
      }
    };
    setTimeout(tick, QZCFG.fastAnalyze ? 30 : 560);
  }

  function computeMatch(){
    const ans = engineAnswers(st.answers);
    const ranked = window.scorePillows(ans);
    st.match = ranked[0];
    st.complement = window.suggestComplement(st.match.id, ans);
    st._engineAns = ans;
    track('product_recommended', {
      pillow: st.match && st.match.id,
      complement: st.complement && st.complement.id,
      confidence: st.match && st.match.confidence,
    });
    // Warm the live product cache now (prices + images) so the rec card renders
    // with real PDP data the moment it appears — the analyzing beat + email gate
    // give the fetch several seconds to land.
    try{ fetchPillowImages(st.match.id); fetchPillowPrices(st.match.id); }catch(e){}
    // simulate the Klaviyo write
    try { console.log('[quiz] Klaviyo profile →', klaviyoProfile(st.answers, st.match.id)); } catch(e){}
  }

  function renderGate(){
    const m = st.match;
    track('email_gate_shown', { pillow: m && m.id });
    const gallery = liveImagesFor(m.id) || (window.LAGOON_PILLOW_GALLERY && window.LAGOON_PILLOW_GALLERY[m.id]) || [];
    const why = whyBullets(m.id, st._engineAns);
    const heroImg = gallery[0] ? '<img src="'+gallery[0]+'" onerror="this.style.display=\'none\'">' : ICON.pcase;
    root.innerHTML = ''+
      '<div class="top"><button class="restart-btn" data-act="restart" title="Start over">'+ICON.restart+'</button>'+
      '<div class="brand">lagoon</div><div class="prog"><div class="prog-track"><div class="prog-fill" style="width:100%"></div></div><span class="prog-label">Match ready</span></div></div>'+
      '<div class="gate">'+
        '<button class="gate-back" data-act="back">'+ICON.chevL+'Back to questions</button>'+
        '<div class="gate-tease">'+
          '<span class="gate-tease-label">✦ Your match is ready</span>'+
          '<div class="gate-preview">'+
            '<div class="gate-preview-img">'+heroImg+'</div>'+
            '<div class="gate-preview-info">'+
              '<div class="gate-preview-name">'+m.name+'</div>'+
              '<ul class="gate-preview-why">'+why.map(b=>'<li>'+ICON.check+'<span>'+b+'</span></li>').join('')+'</ul>'+
            '</div>'+
          '</div>'+
          '<div class="gate-preview-lock">'+ICON.lock+'Enter your email to reveal your match</div>'+
        '</div>'+
        '<h2 class="gate-h">Unlock $20 off + your match</h2>'+
        '<p class="gate-p">We\'ll reveal your match and email your $20 code.</p>'+
        '<input class="gate-input" placeholder="your@email.com" />'+
        '<label class="gate-consent"><input type="checkbox" checked /> <span>Sign up for Lagoon news, sleep tips &amp; exclusive offers.</span></label>'+
        '<button class="gate-cta">Reveal my match &amp; unlock $20</button>'+
        '<button class="gate-skip">No thanks, just show my match</button>'+
        '<div class="gate-founder">'+
          '<div class="gate-founder-head">'+
            '<div class="gate-founder-photo"><img src="'+FOUNDER_PHOTO+'" alt="Ryan Hurley" onerror="this.style.display=\'none\'"></div>'+
            '<div><div class="gate-founder-name">Ryan Hurley</div><div class="gate-founder-role">Founder, Lagoon · replies personally</div></div>'+
          '</div>'+
          '<div class="gate-founder-quote">"I don\'t just want you to sleep well — I want you to <b>sleep your best</b>. If your match isn\'t perfect, just email me."</div>'+
        '</div>'+
      '</div>';
    bindChrome();
    wireGate();
  }

  function wireGate(){
    const cta = root.querySelector('.gate-cta');
    const skip = root.querySelector('.gate-skip');
    if(cta) cta.onclick = function(){
      const inp = root.querySelector('.gate-input');
      const email = (inp && inp.value || '').trim();
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){
        let err = root.querySelector('.gate-err');
        if(!err){ err = document.createElement('div'); err.className = 'gate-err'; if(inp) inp.insertAdjacentElement('afterend', err); }
        err.textContent = 'Please enter a valid email — or skip below.';
        if(inp) inp.focus(); return;
      }
      syncKlaviyo(email);
      st.phase='result'; st.cIdx=0; renderResult();
    };
    if(skip) skip.onclick = function(){ track('email_gate_skipped', { pillow: st.match && st.match.id }); st.phase='result'; st.cIdx=0; renderResult(); };
  }

  function renderResult(){
    const m = st.match, c = st.complement;
    track('results_shown', { pillow: m && m.id, complement: c && c.id });
    let gallery = liveImagesFor(m.id) || (window.LAGOON_PILLOW_GALLERY && window.LAGOON_PILLOW_GALLERY[m.id]) || [];
    const why = whyBullets(m.id, st._engineAns);
    const confLine = confidenceLine(st._engineAns);
    // Live prices populate from each PDP in production; until then (and in this
    // preview, where the fetch is cross-origin) fall back to the engine base
    // price plus a representative King delta so the size toggle still demos.
    let livePillow = null, liveCase = null;
    const PREVIEW_KING_DELTA = { pillow: 20, case: 10 };
    const priceSet = (size) => {
      const up = size === 'King' ? 1 : 0;
      const pp = (livePillow && livePillow[size] != null) ? livePillow[size] : (m.price + up * PREVIEW_KING_DELTA.pillow);
      const cp = (liveCase && liveCase[size] != null) ? liveCase[size] : (c.price + up * PREVIEW_KING_DELTA.case);
      return { pillowWas: pp, pillowNow: pp - 20, bundleWas: pp + cp, bundleNow: pp + cp - 40 };
    };
    const P = priceSet(st.size);
    const chips = secondaryChips(st.answers.goals);

    const buildCarousel = (imgs)=>
      '<div class="carousel"><div class="carousel-hero" data-carousel>'+
        imgs.map((src,i)=>'<img class="carousel-img'+(i===st.cIdx?' on':'')+'" src="'+src+'" data-i="'+i+'" onerror="this.style.display=\'none\'">').join('')+
        (imgs.length>1?'<button class="carousel-nav carousel-prev" data-cnav="-1">'+ICON.chevL+'</button><button class="carousel-nav carousel-next" data-cnav="1">'+ICON.chevR+'</button>'+
        '<div class="carousel-dots">'+imgs.map((_,i)=>'<button class="carousel-dot'+(i===st.cIdx?' on':'')+'" data-cgo="'+i+'"></button>').join('')+'</div>':'')+
      '</div>'+
      (imgs.length>1?'<div class="carousel-thumbs">'+imgs.map((src,i)=>'<button class="carousel-thumb'+(i===st.cIdx?' on':'')+'" data-cgo="'+i+'"><img src="'+src+'" onerror="this.parentElement.style.display=\'none\'"></button>').join('')+'</div>':'')+
      '</div>';
    const carousel = buildCarousel(gallery);

    const fmtWhy = (b)=>{ const i=b.indexOf(' — '); return i>0 ? '<strong>'+b.slice(0,i)+'</strong>'+b.slice(i) : b; };
    const info =
      '<div class="res-info">'+
        '<div class="res-namerow">'+
          '<div class="res-namecol">'+
            '<div class="res-info-eyebrow">YOUR LAGOON FIT</div>'+
            '<a class="res-info-name" href="'+offerLink(pdpUrl(m), DISCOUNT_CODE)+'" target="_blank" rel="noopener">'+m.name+'</a>'+
          '</div>'+
          '<div class="res-match-badge"><span class="res-match-score">✦ '+m.confidence+'% match</span></div>'+
        '</div>'+
        '<div class="res-info-feel">'+m.tagline+'</div>'+
        '<div class="res-stars" data-fera-container="product_rating" data-fera-product-id="'+m.id+'">'+
          '<span class="res-stars-glyph">★★★★★</span><span>4.8 · 16,000+ verified reviews</span></div>'+
        '<div class="res-why-card">'+
          '<div class="res-why-head">✦ Why the '+m.name.replace('The ','')+' fits you</div>'+
          '<ul class="res-why">'+why.map(b=>'<li><span class="chk">'+ICON.check+'</span><span>'+fmtWhy(b)+'</span></li>').join('')+'</ul>'+
        '</div>'+
      '</div>';

    const offer =
      '<div class="offer">'+
        '<div class="offer-card'+(st.bundle?'':' on')+'" data-bundle="0">'+
          '<div class="offer-card-name">'+m.name+' only</div>'+
          '<div class="offer-card-sub">Just the pillow</div>'+
          '<div class="offer-card-price"><span class="offer-card-was offer-pw">$'+P.pillowWas.toFixed(2)+'</span><span class="offer-card-now offer-pn">$'+P.pillowNow.toFixed(2)+'</span><span class="offer-card-save">SAVE $20</span></div>'+
        '</div>'+
        '<div class="offer-card best'+(st.bundle?' on':'')+'" data-bundle="1">'+
          '<span class="offer-card-ribbon">Best deal</span>'+
          '<div class="offer-card-name">Pillow + Pillowcase</div>'+
          '<div class="offer-card-sub">Your perfect sleep setup</div>'+
          '<div class="offer-card-price"><span class="offer-card-was offer-bw">$'+P.bundleWas.toFixed(2)+'</span><span class="offer-card-now offer-bn">$'+P.bundleNow.toFixed(2)+'</span><span class="offer-card-save">SAVE $40</span></div>'+
        '</div>'+
      '</div>';

    const pcLine =
      '<div class="res-pc"><div class="res-pc-ico">'+ICON.pcase+'</div>'+
        '<div class="res-pc-txt"><div class="res-pc-name">Pairs with the <a href="'+offerLink(pcaseUrl(c), DISCOUNT_CODE)+'" target="_blank" rel="noopener" class="res-pc-link">'+c.name+'</a></div>'+
        '<div class="res-pc-why">'+c.why+'</div></div></div>';

    const trialBand =
      '<div class="res-trial">'+ICON.shield+
        '<div><div class="res-trial-t">Try it 100 nights — risk-free</div><div class="res-trial-s">Love it or send it back. We pay return shipping.</div></div>'+
      '</div>';
    const starSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l2.4 7.2H22l-6.2 4.5L18.2 21 12 16.5 5.8 21l2.4-7.3L2 9.2h7.6z"/></svg>';
    const trustrow =
      '<div class="res-trustrow">'+
        '<div class="res-trust">'+starSvg+'<b>24,000+</b><span>happy sleepers</span></div>'+
        '<div class="res-trust">'+ICON.truck+'<b>Free</b><span>shipping</span></div>'+
        '<div class="res-trust">'+ICON.badge+'<b>5-year</b><span>warranty</span></div>'+
      '</div>';

    root.innerHTML = ''+
      '<div class="res">'+
        '<div class="res-hero">'+
          '<button class="res-hero-back" data-act="back">'+ICON.chevL+'Back</button>'+
          '<button class="restart-btn" data-act="restart" style="background:rgba(255,255,255,.14);border:none;color:#fff" title="Start over">'+ICON.restart+'</button>'+
          '<div class="res-supertext">Based on your answers, here\'s your prescription to</div>'+
          '<div class="res-outcome">'+outcomeHeadline(st.answers.goals)+'</div>'+
        '</div>'+
        '<div class="res-body">'+
          '<div class="res-main">'+info+'<div class="res-carousel-wrap">'+carousel+'</div></div>'+
          pcLine+
          offer+
          '<div class="res-size"><span class="res-size-label">Size</span><div class="res-size-toggle">'+
            ['Queen','King'].map(s=>'<button class="res-size-btn'+(st.size===s?' on':'')+'" data-size="'+s+'">'+s+'</button>').join('')+
          '</div></div>'+
          trialBand+
          '<button class="res-atc">'+(st.bundle?'Add bundle to cart — Save $40':'Add to cart')+'</button>'+
          trustrow+
          '<a class="res-secondary" href="'+offerLink(pdpUrl(m), DISCOUNT_CODE)+'" target="_blank" rel="noopener">Learn more about the '+m.name.replace('The ','')+' →</a>'+
        '</div>'+
      '</div>';

    // carousel nav (direct DOM, no full re-render)
    const setC = (i)=>{ const g=gallery.length; st.cIdx=((i%g)+g)%g;
      root.querySelectorAll('.carousel-img').forEach((el,k)=>el.classList.toggle('on',k===st.cIdx));
      root.querySelectorAll('.carousel-dot').forEach((el,k)=>el.classList.toggle('on',k===st.cIdx));
      root.querySelectorAll('.carousel-thumb').forEach((el,k)=>el.classList.toggle('on',k===st.cIdx));
    };
    root.querySelectorAll('[data-cnav]').forEach(b=>b.onclick=()=>setC(st.cIdx+parseInt(b.dataset.cnav,10)));
    root.querySelectorAll('[data-cgo]').forEach(b=>b.onclick=()=>setC(parseInt(b.dataset.cgo,10)));
    // If the live PDP images weren't cached yet at render time, swap them in
    // when the fetch lands (keeps the curated gallery as the instant fallback).
    if(!liveImagesFor(m.id)){
      fetchPillowImages(m.id).then(imgs=>{
        if(!imgs || !imgs.length) return;
        const wrap = root.querySelector('.res-carousel-wrap');
        if(!wrap) return;
        gallery = imgs; st.cIdx = 0;
        wrap.innerHTML = buildCarousel(gallery);
        root.querySelectorAll('[data-cnav]').forEach(b=>b.onclick=()=>setC(st.cIdx+parseInt(b.dataset.cnav,10)));
        root.querySelectorAll('[data-cgo]').forEach(b=>b.onclick=()=>setC(parseInt(b.dataset.cgo,10)));
      });
    }
    const updateBundle = ()=>{
      root.querySelectorAll('.offer-card').forEach(card=>card.classList.toggle('on',(card.dataset.bundle==='1')===st.bundle));
      const atc = root.querySelector('.res-atc');
      if(atc) atc.textContent = st.bundle ? 'Add bundle to cart — Save $40' : 'Add to cart';
    };
    const updateSize = ()=>{
      root.querySelectorAll('.res-size-btn').forEach(b=>b.classList.toggle('on',b.dataset.size===st.size));
      const ps = priceSet(st.size);
      const set=(sel,val)=>{ const el=root.querySelector(sel); if(el) el.textContent='$'+val.toFixed(2); };
      set('.offer-pw', ps.pillowWas); set('.offer-pn', ps.pillowNow);
      set('.offer-bw', ps.bundleWas); set('.offer-bn', ps.bundleNow);
    };
    root.querySelectorAll('[data-bundle]').forEach(b=>b.onclick=()=>{ st.bundle = b.dataset.bundle==='1'; updateBundle(); });
    root.querySelectorAll('[data-size]').forEach(b=>b.onclick=()=>{ st.size = b.dataset.size; updateSize(); });
    // Pull live per-variant prices (Queen & King) from each PDP; refresh on arrival.
    const atcBtn = root.querySelector('.res-atc');
    if(atcBtn) atcBtn.onclick = function(){ addToCart(m, c); };
    root.querySelectorAll('a.res-info-name, .res-secondary, .res-pc-link').forEach(a=>a.addEventListener('click', function(){ track('pdp_click', { pillow: m.id, href: a.getAttribute('href') }); }));
    fetchPillowPrices(m.id).then(map=>{ if(map){ livePillow = map; updateSize(); } });
    fetchCasePrices(c.id).then(map=>{ if(map){ liveCase = map; updateSize(); } });
    bindChrome();
  }

  function bindChrome(){
    root.querySelectorAll('[data-act]').forEach(b=>{
      const act = b.dataset.act;
      b.onclick = ()=>{
        if(act==='restart'){ track('retake', { from: st.phase }); st.step=0; st.phase='quiz'; st.answers={goals:[]}; st.cIdx=0; st.bundle=false; st.size='Queen'; st.started=false; st.entryId=null; paintQuestion(); }
        else if(act==='continue'){ advance(); }
        else if(act==='reveal'){ st.phase='result'; st.cIdx=0; renderResult(); }
        else if(act==='back'){
          track('step_back', { phase: st.phase, step: st.step+1 });
          if(st.phase==='result'){ st.phase='gate'; renderGate(); }
          else if(st.phase==='gate'){ st.phase='quiz'; st.step=TOTAL-1; paintQuestion(); }
          else if(st.step>0){ st.step--; slideQuestion(-1); }
        }
      };
    });
  }

  paintQuestion();
}

function boot(){
  if(!window.scorePillows){ setTimeout(boot, 60); return; }
  document.querySelectorAll('.lagoon-quiz .lq-screen').forEach(function(scr){
    // Re-init if never mounted OR if the screen somehow got emptied (blank-screen guard).
    if(scr.__lqInit && scr.childElementCount > 0) return;
    scr.__lqInit = true; createQuiz(scr);
  });
}
boot();
document.addEventListener('DOMContentLoaded', boot);
window.addEventListener('pageshow', boot);                 // recover from bfcache (back button)
document.addEventListener('shopify:section:load', boot);   // re-mount in theme editor
